module.exports = __webpack_public_path__ + "static/media/Relationships.38993cd2.png";